module.exports = __webpack_public_path__ + "static/img/GLENN_MCGRATH.3a1dc10.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GLENN_MCGRATH.jpg
// module id = 8XeQ
// module chunks = 0